import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import RouteWithTrips, { CarLocation } from "@/components/Passenger/models/RouteWithTrips";
import RouteFeature from "../Features/RouteFeature";
import restService from "@/services/restService";
import moment from "moment";
import CarFeature from "../Features/CarFeature";
import Trip from "@/components/Passenger/models/Trip";

export default class CarLayer extends VectorLayer<VectorSource> {
  car: CarFeature;
  carSource = new VectorSource();
  interval: any;
  route: RouteFeature;
  trip: Trip;

  constructor(route: RouteWithTrips, tripId: number, options?: any) {
    super({ zIndex: 3, ...options });
    this.setSource(this.carSource);
    this.trip = route.trips.find(t => t.id === tripId);
  }

  showDrivenRoute(route: CarLocation[]) {
    this.route = new RouteFeature(route);
    this.carSource.addFeature(this.route);
  }

  async startUpdatingLiveLocation() {
    await this.getCarLocation();
    this.interval = setInterval(async () => {
      await this.getCarLocation();
    }, 10000);
  }

  stopUpdatingLiveLocation() {
    clearInterval(this.interval);
    this.carSource.removeFeature(this.car);
    this.car = null;
  }

  private async getCarLocation() {
    const date = moment(this.trip.startDateTime || this.trip.endDateTime).format("YYYY-MM-DD");
    const currentLocation = await restService.passengers.getCarLocationByTripId(this.trip.passenger.timitId, this.trip.id, date);

    if (!this.route) {
      this.route = new RouteFeature([currentLocation]);
      this.carSource.addFeature(this.route);
    } else {
      this.route.addLocationToRoute(currentLocation);
    }

    if (!this.car) {
      this.car = new CarFeature(currentLocation, this.trip.carName ?? this.trip.carRegisterNumber);
      this.carSource.addFeature(this.car);
    } else {
      this.car.updateLocation(currentLocation);
    }
  }
}